import React from "react";

export default (props) => {

	const { top, left } = props;

	let tooltipTextClass = `tooltip__text tooltip__text--${top ? "top" : "bottom"}-${left ? "left" : "right"}`;

	let svg = require("../../../../assets/icons/help.svg");

	return (
		<span className={`tooltip ${props.className}`}>
			<i className="icon icon--medium tooltip__icon" dangerouslySetInnerHTML={{__html: svg}} />
			<span className={tooltipTextClass}>{props.children}</span>
		</span>
	);
};



// WEBPACK FOOTER //
// ./src/js/common/components/form/Tooltip.js